'use client'
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Icon,
  Typography,
} from '@repo/ui/components'
import Image from 'next/image'
import React, { useState } from 'react'
import { useTranslate } from '../..'
import type { CSSVariableColor } from '@repo/ui/types'

interface InformationDialogProps {
  title: string
  children: React.ReactNode
  icon?: React.ReactNode
  iconColor?: CSSVariableColor
  mediaType?: 'image' | 'video' | 'text'
  mediaUrl?: string
}

export const InformationDialog = (props: InformationDialogProps) => {
  const {
    title,
    children,
    icon,
    mediaType = 'text',
    mediaUrl,
    iconColor = 'fill-neutral-surface-20',
  } = props
  const [open, setOpen] = useState(false)
  const { t } = useTranslate()

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger className='flex'>
        {icon ?? (
          <Icon
            name='InfoCircle'
            size='xs'
            color={iconColor}
            className='cursor-pointer'
          />
        )}
      </DialogTrigger>
      <DialogContent className='w-full sm:max-w-[450px] !px-0'>
        <DialogHeader className='flex flex-col gap-2xs'>
          <DialogTitle className='text-center mb-md'>
            <Typography
              size='md'
              color='text-neutral-surface-100'
              weight='bold'
            >
              {title}
            </Typography>
          </DialogTitle>
          {mediaType === 'video' && mediaUrl && (
            <video
              src={mediaUrl}
              controls
              className='rounded-md w-full h-auto'
            />
          )}

          {mediaType === 'image' && mediaUrl && (
            <Image
              src={mediaUrl}
              alt={title}
              width={450}
              height={450}
              // sizes='(max-width: 450px) 100vw'
              className='rounded-md w-full h-auto'
            />
          )}
        </DialogHeader>
        <div className='text-md text-neutral-surface-100 max-h-[50dvh] overflow-y-auto px-md'>
          {children}
        </div>
        <DialogFooter className='flex flex-col gap-md px-md'>
          <Button
            onClick={() => setOpen(false)}
            width='full'
            variant='ghost'
            color='neutral'
          >
            {t('common_back')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
